import PatientInfo from '@/components/patients/primitives/PatientInfo.vue'
import PatientName from '@/components/patients/primitives/PatientName.vue'
import Vue from 'vue'

Vue.component('patient-name', PatientName)
Vue.component('patient-info', PatientInfo)
